import { IRemapper } from "../../../../Global/IRemapper";
import LeadModel from "../Lead/LeadModel";
import LeadRequestBody from "../Lead/LeadRequestBody";

export default class LeadRemapper implements IRemapper<LeadModel> {
  toRequest(requestBody: LeadRequestBody) {
    return {
      first_name: requestBody.firstName || null,
      last_name: requestBody.lastName || null,
      full_name: requestBody.fullName || null,
      email: requestBody.email || null,
      gender: requestBody.gender || null,
      country: requestBody.country || null,
      phone_country_code: requestBody.phoneCountryCode || null,
      phone_number: requestBody.phoneNumber || null,
      campaign_id: requestBody.campaignId || null,
      campaign_name: requestBody.campaignName || null,
      content_type: requestBody.contentType || null,
      content_id: requestBody.contentId || null,
      content_name: requestBody.contentName || null,
      custom_fields: requestBody.customFields || null,
    };
  }

  fromResponse(response: any) {
    const model = new LeadModel();

    model.leadId = response.lead_id;
    model.profileId = response.profile_id;
    model.firstName = response.first_name;
    model.lastName = response.last_name;
    model.fullName = response.full_name;
    model.email = response.email;
    model.gender = response.gender;
    model.country = response.country;
    model.phoneCountryCode = response.phone_country_code;
    model.phoneNumber = response.phone_number;
    model.campaignId = response.campaign_id;
    model.campaignName = response.campaign_name;
    model.contentId = response.content_id;
    model.contentType = response.content_type;
    model.contentName = response.content_name;
    model.customFields = response.custom_fields;

    return model;
  }
}
